<template>
    <div v-if="this.action === 'BLOCK_COMPANY'">
        <b-modal
            hide-footer
            :title="modalTitle"
            v-model="modal.show"
            size="md"
        >
        <d-row>
            <d-col>
                <div class="shadow-sm bg-gray-100 p-3 rounded mb-3">
                    <h5><strong>Empresa: </strong>{{ company.nombre }}</h5>
                </div>
            </d-col>
            <d-col>
                <b-form
                    method="POST"
                    data-vv-scope="general"
                    @submit.prevent="submitForm()"
                >
                    <b-row class="mt-4">
                        <b-col sm="12" v-if="companyBlockade.type === null">
                            <b-form-group>
                                <label for="type" class="d-block"
                                >Tipo de acción <span class="text-danger">*</span>
                                </label>
                                <el-select v-model="companyBlockade.type">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12">
                            <b-form-group>
                                <label for="description" class="d-block"
                                >Descripción <span class="text-danger">*</span>
                                </label>
                                <b-form-textarea
                                    id="description"
                                    v-model="companyBlockade.description"
                                    v-validate="'required'"
                                >
                                </b-form-textarea>
                                <span
                                    class="text-danger span-error small"
                                    v-text="errors.first('general.description')"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-button variant="primary" class="float-right" type="submit">
                            Guardar
                            </b-button>
                            <b-button class="float-right mr-2" @click="resetBlockCompany()">
                            Cancelar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </d-col>
        </d-row>
        </b-modal>
    </div>


</template>
<script>
    import {mapState,mapActions} from "vuex"

    export default {
        name: "modal",
        props:['refreshAction'],
        data() {
            return {
                createBlocked:false,
                options: [
                    {value:'BLOCKED',text:'Asegurar'},
                    {value:'UNBLOCKED',text:'Liberar'}
                ]
            }
        },
        methods: {
            ...mapActions('companyBlockades', ['resetBlockCompany','createCompanyBlock','blockCompanySubmit']),
            ...mapActions('empresa', ['listarEmpresas']),
            async submitForm() {
                this.$validator.validateAll("general").then(async (result) => {
                    if(result) {
                        await this.createCompanyBlock().then(async ()=>{
                            await this.listarEmpresas();
                            this.resetBlockCompany();
                            this.$emit('data-event',null);
                        });
                    }
                });
            }
        },
        computed: {
            ...mapState('companyBlockades', ['modal','companyBlockade','action','company']),
            modalTitle(){
                return (this.company.insured_status === 'BLOCKED') ? 'Liberar empresa' : 'Asegurar empresa';
            }
        }
    }
</script>
